import { Injectable } from '@angular/core';

@Injectable()
export class TextEditorSelectionElementBuilderService {
    private range: Range;

    constructor() {}

    setCurrentRange(currentRange: Range) {
        this.range = currentRange;
    }

    getCurrentRange() {
        return this.range;
    }
}
